import React from 'react';
import { Button } from 'antd';
import { useTranslation } from 'react-i18next';

export const ButtonCreateService = ({ openCreate }) => {
  const { t } = useTranslation();
  const handleClickButtonCreateService = () => {
    openCreate();
  };

  return (
    <Button type="primary" onClick={handleClickButtonCreateService}>
      {t('governmentServiceEducation.create')}
    </Button>
  );
};
